import React, { useEffect } from 'react';
import { Button, Card, Col, Container, Form, Modal, Offcanvas, Row, ListGroup, InputGroup } from 'react-bootstrap';
// import '../../Scss/Form.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import RHFTextField from '../../FunctionalComponent/FormElement/RHTextField';
import FormProvider from '../../FunctionalComponent/FormElement/FormProvider';
import RHSelectField from '../../FunctionalComponent/FormElement/RHSelectField';
import { useCreate_Update_sizeMutation, useGetsizeMutation } from '../../Redux/SizeSlice';
import { useDispatch, useSelector } from 'react-redux';



function CreateSize(props) {
    const { setOpen, SizeData, open } = props;
    const [CreateUpdateSizeFunc] = useCreate_Update_sizeMutation();
    const [GetsizeFunc] = useGetsizeMutation();
    const navigate = useNavigate();
    const dispatch = useDispatch();


    let title = {
        header: `Size ${SizeData?.id ? 'Update' : 'Add'}`,
        submit: `${SizeData?.id ? 'Update' : 'Save'}`
    };

    let initialState = {
        name: '',
        slug: '',
        status: ''
    };

    const schema = Yup
        .object({
            name: Yup
                .string()
                .required()
                .strict(true)
                .trim('White spaces before and after are not allow'),
            slug: Yup
                .string()
                .required()
                .strict(true)
                .trim('White spaces before and after are not allow'),
            // status: Yup.string().required(),
            status: Yup.string().required('Status is required'),
        })
        .required();

    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues: initialState,
        mode: 'all',
    });
    const {
        handleSubmit,
        reset,
        setError,
        setValue,
        getValues,
    } = methods;

    const onSubmit = () => {
        const data = getValues();
        CreateUpdateSizeFunc({ ...data, id: SizeData?.id }).then(async (res) => {
            if (res?.data?.statusCode == 200) {
                setOpen(false)
            }
        })
    }
    useEffect(() => {
        if (SizeData?.id) {
            GetsizeFunc(SizeData?.id).then(res => {
                const getsizedata = res?.data?.response
                Object.keys(initialState).forEach((fieldname) => {
                    setValue(fieldname, getsizedata[`${fieldname}`]);
                })

            })
        }
    }, [SizeData?.id])

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <>
            <Modal id="showModal" className="fade zoomIn" size="lg" title={title}
                show={open} onHide={() => { setOpen(!open) }} centered>
                <Modal.Header className="px-4 pt-4" closeButton>
                    <h5 className="modal-title fs-18" id="exampleModalLabel">Add Size</h5>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <FormProvider className="tablelist-form" methods={methods} onSubmit={handleSubmit(onSubmit)} >
                        <Row>
                            <div id="alert-error-msg" className="d-none alert alert-danger py-2"></div>
                            <input type="hidden" id="id-field" />
                            <Col lg={12}>
                                <div className="mb-3">
                                    <RHFTextField
                                        name='name'
                                        label='Size Name'
                                        required={true}
                                        onChange={(e) => {
                                            setValue('name', e.target.value, {
                                                shouldDirty: true,
                                                shouldTouch: true,
                                                shouldValidate: true,
                                            });
                                            setValue('slug', e.target.value.toLowerCase().replace(/\s+/g, '-'), {
                                                shouldDirty: true,
                                                shouldTouch: true,
                                                shouldValidate: true,
                                            });
                                        }}
                                    />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="mb-3">
                                    <RHFTextField name='slug' label='Slag Url' required={true} />
                                </div>
                            </Col>

                            <Col lg={6}>
                                <div className="mb-3">
                                    <RHSelectField
                                        name='status'
                                        label='Size Status'
                                        required={true}
                                        list={[
                                            { name: 'Active', value: true },
                                            { name: 'Inactive', value: false },
                                        ]}
                                    />
                                </div>
                            </Col>
                            <Col lg={12} className="modal-footer">
                                <div className="hstack gap-2 justify-content-end">
                                    <Button className="btn-ghost-danger" onClick={() => { setOpen(!open) }}><i className="ri-close-line align-bottom me-1"></i> Close</Button>
                                    <Button variant='primary' id="add-btn" type="submit">Save</Button>
                                </div>
                            </Col>
                        </Row>
                    </FormProvider>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default CreateSize;
